// assets
import { ProfileOutlined, UserOutlined } from '@ant-design/icons';

// icons
const icons = {
  UserOutlined,
  ProfileOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'authentication',
  title: 'Authentication',
  type: 'group',
  children: [
    {
      id: 'my-profile',
      title: 'My Profile',
      type: 'item',
      url: '/profile',
      icon: icons.UserOutlined,
      target: false,
      breadcrumbs: false,
    }
  ]
};

export default pages;
